import { apApi } from '@/services/api/instances';

// Backward-compatible boot API for the AP (default) client.
export const configureApiClient = apApi.configure;
export const getConfig = apApi.getConfig;
